var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"right-side-button",class:{
        'right-side-button': _vm.issideright,
        smclass: _vm.$breakpoint.xsOnly || _vm.btntwo,
        'overlay-radius': _vm.$breakpoint.mdAndDown,
        'three-btn': _vm.threeBtn
    },attrs:{"z-index":"1","absolute":"","rounded":"","value":true}},[(_vm.text !== 'No Text')?_c('v-btn',{staticClass:"grey lighten-2",attrs:{"depressed":"","tile":"","small":!_vm.isBothFancyVisibleOnDesktop,"x-small":_vm.isBothFancyVisibleOnDesktop,"light":""}},[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }